import { faHouse, faGlobe } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MirageTheme } from "@mirage/theme/MuiMirage.module";
import { IconButton } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { memo } from "react";

interface AutocompleteIconProps {
    selectedGazetteer: "local" | "national";
    gazetteerIconOnClick(): void;
    gazetteerChoice?: boolean;
    hideGazetteerIcon?: boolean;
}

const AutocompleteIcon: React.FC<AutocompleteIconProps> = memo(({ selectedGazetteer, gazetteerChoice, gazetteerIconOnClick, hideGazetteerIcon }) => {
    const icon = selectedGazetteer === "local" ? faHouse : faGlobe;
    const gazetteerIcon = <FontAwesomeIcon icon={icon} style={MirageTheme.icons.sizeS} color={gazetteerChoice ? MirageTheme.palette.primary.main : undefined} />;

    if (hideGazetteerIcon) {
        return null;
    }
    return (
        <Tooltip title={gazetteerChoice ? (selectedGazetteer === "local" ? "Switch to national gazetteer" : "Switch to local gazetteer") : ""}>
            <IconButton aria-label="use national gazetteer" onClick={gazetteerIconOnClick} disabled={!gazetteerChoice}>
                {gazetteerIcon}
            </IconButton>
        </Tooltip>
    );
});

export default AutocompleteIcon;
